export default __webpack_public_path__ + "static/media/Honeywell.8943e29c.png";